/**
 * Chart colours for the Organic analytics tab. Same validated categorical slots
 * as casesPalette (slot 1 blue, slot 2 orange) plus slots 3-4, in the order the
 * mockup uses them. Colour follows the LINE a caller dialled, never its rank:
 * pool-matched is always blue, the main 1770 line always green, and so on, so a
 * slice appearing or disappearing never repaints the others.
 */

export interface OrganicPalette {
    matched: string;
    unmatched: string;
    organicDefault: string;
    organicPoolFull: string;
    canonical: string;
    gbp: string;
    other: string;
    callers: string;
    qualified: string;
    grid: string;
    axis: string;
    muted: string;
    good: string;
    warning: string;
    critical: string;
    waiting: string;
}

const LIGHT: OrganicPalette = {
    matched: '#2a78d6',
    unmatched: '#eb6834',
    organicDefault: '#7c5cc4',
    organicPoolFull: '#c4508f',
    canonical: '#1baf7a',
    gbp: '#eda100',
    other: '#898781',
    callers: '#2a78d6',
    qualified: '#eb6834',
    grid: '#e1e0d9',
    axis: '#c3c2b7',
    muted: '#898781',
    good: '#0ca30c',
    warning: '#fab219',
    critical: '#d03b3b',
    waiting: '#c3c2b7',
};

const DARK: OrganicPalette = {
    matched: '#3987e5',
    unmatched: '#d95926',
    organicDefault: '#9478d6',
    organicPoolFull: '#d668a4',
    canonical: '#199e70',
    gbp: '#c98500',
    other: '#898781',
    callers: '#3987e5',
    qualified: '#d95926',
    grid: '#2c2c2a',
    axis: '#383835',
    muted: '#898781',
    good: '#0ca30c',
    warning: '#fab219',
    critical: '#d03b3b',
    waiting: '#383835',
};

export const organicPalette = (mode: 'light' | 'dark'): OrganicPalette =>
    mode === 'dark' ? DARK : LIGHT;
